export default "/fonts/vendor/@fontsource/lato/files/lato-latin-300-normal.woff2?dc76fa21c09d3cec2243b9edef724982";